import { getFaroEnvironment, isFaroEnabled, type FaroEnvironment } from '@/plugins/faro-config.ts';

type FaroAdapter = typeof import('@/plugins/faro.ts');
let initialization: Promise<FaroAdapter | null> | undefined;

const initializeFaroTelemetry = async (
    env: FaroEnvironment = getFaroEnvironment()
): Promise<boolean> => {
    if (!isFaroEnabled(env)) {
        return false;
    }
    initialization ??= import('@/plugins/faro.ts')
        .then((adapter) => (adapter.initializeFaroTelemetry(env) ? adapter : null))
        .catch(() => null);
    return Boolean(await initialization);
};

const captureFaroError = (error: unknown): void => {
    // Errors during chunk loading wait for initialization without loading Faro on disabled sites.
    initialization?.then((adapter) => adapter?.captureFaroError(error)).catch(() => {});
};

export { initializeFaroTelemetry, captureFaroError };
